import React from 'react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
import { PackagePricing } from '../components/PackagePricing';
import { FeatureItem } from '../components/FeatureItem';
import { RelatedLinks } from '../components/RelatedLinks';
import { packages } from '../data/packages';
const pkg = packages.find(p => p.slug === 'full-detail')!;
const faqs = [{
  question: 'What is included in a full car detail?',
  answer: 'A full detail combines our complete interior and exterior services: deep vacuuming, shampooing, steam sanitizing, leather conditioning, a safe hand wash, clay bar decontamination, wheel and tire detailing, and premium paint protection.'
}, {
  question: 'How long does a full detail take?',
  answer: 'A full detail typically takes 3\u20134 hours depending on the size and condition of your vehicle. We never rush \u2014 quality results take proper time and attention.'
}, {
  question: 'How much does a full car detail cost?',
  answer: 'Our full detail is $300 for small and mid-size vehicles and $350 for SUVs and crossovers. Call or text (818) 381-9905 for an exact quote.'
}, {
  question: 'Is a full detail worth it before selling my car?',
  answer: 'Absolutely. A full detail is one of the most cost-effective ways to maximize resale value, presenting your vehicle in its best possible condition inside and out.'
}, {
  question: 'Do you come to my home or office for a full detail?',
  answer: 'Yes. We are fully mobile, bringing our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
}];
export function FullDetailPage() {
  return <ServicePageLayout title="Full Detail" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Mobile Full Detail in Ventura County — complete interior deep clean plus exterior wash, clay bar and hybrid ceramic spray. $300 SM/Mid, $350 SUV. Call or text 818-381-9905." schema={{
    '@type': 'Service',
    name: 'Full Detail',
    serviceType: 'Mobile Full Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail"
    },
    areaServed: ['Ventura County', 'Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks'],
    description: 'Complete mobile full car detailing combining deep interior cleaning with an exterior wash, clay bar treatment, and hybrid ceramic spray protection.',
    offers: [{
      '@type': 'Offer',
      price: '300',
      priceCurrency: 'USD',
      description: 'Small / mid-size vehicle'
    }, {
      '@type': 'Offer',
      price: '350',
      priceCurrency: 'USD',
      description: 'SUV / crossover'
    }]
  }} faqs={faqs} breadcrumbs={[{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Full Detail',
    item: 'https://www.fulldetailpro.com/full-detail'
  }]} data-id="element-986" data-mp="221a2uk7o4e97">
      <p data-id="element-987" data-mp="369qcd8v1fx18">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-988" data-mp="3k9j519q4knbu">Full Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing — delivered directly to your driveway or workplace
        anywhere in Ventura County.
      </p>

      <PackagePricing pkg={pkg} data-id="element-989" data-mp="2nkjshiiiczdu" />

      <figure className="not-prose my-10" data-id="element-990" data-mp="2nh5s2ften091">
        <img src="https://cdn.magicpatterns.com/uploads/ned8mdPgcS8nYQ5VpmCn7T/Red_BMW_.jpg" alt="Red BMW M4 convertible after a mobile full detail with a showroom shine" loading="lazy" decoding="async" className="w-full h-auto rounded-xl border border-zinc-800" data-id="element-991" data-mp="31awzninksa24" />
      </figure>

      <h2 data-id="element-992" data-mp="23vj3xvfjmrn0">What Goes Into a Full Detail</h2>
      <p data-id="element-993" data-mp="23uhtnt6cq96c">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-994" data-mp="2mi4gtdve8krj">Exterior Services</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-995" data-mp="2meyto46brsyg">
        <FeatureItem data-id="element-996" data-mp="2rfw8c6s4m4v7">Wash method to safely remove surface dirt and grime.</FeatureItem>
        <FeatureItem data-id="element-997" data-mp="2w7edl716mrlz">
          <strong data-id="element-998" data-mp="2w7xs0drmixv9">Decontamination & Clay Bar:</strong> Removal of embedded iron
          particles, tree sap, and road tar to leave the paint smooth.
        </FeatureItem>
        <FeatureItem data-id="element-999" data-mp="3571ezstwvxf1">
          <strong data-id="element-1000" data-mp="356jbcb4x6gx3">Wheel & Tire Detail:</strong> Deep cleaning of wheel barrels,
          faces, and tires, finished with a premium no-sling dressing.
        </FeatureItem>
        <FeatureItem data-id="element-1001" data-mp="3f5gu0xfnzg86">
          <strong data-id="element-1002" data-mp="3f4paikzcd8y9">Paint Protection:</strong> Application of a{' '}
          <Link to="/services/hybrid-ceramic-spray" data-id="element-1003" data-mp="1fsmkst04jic5">hybrid ceramic spray</Link>{' '}
          for gloss and water beading.
        </FeatureItem>
      </ul>

      <h3 data-id="element-1004" data-mp="1ks96lqu0q6wk">Interior Services</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1005" data-mp="1ktk8tm7tf6lk">
        <FeatureItem data-id="element-1006" data-mp="1xeh7r7rysdj">
          <strong data-id="element-1007" data-mp="1xwbiiavmwit">Deep Vacuuming:</strong> Thorough removal of dirt and pet
          hair, followed by steam cleaning carpets and cloth seats.
        </FeatureItem>
        <FeatureItem data-id="element-1008" data-mp="3paqk51rba4yv">
          <strong data-id="element-1009" data-mp="3pa6zhdaa12h5">Leather Treatment:</strong> Gentle cleaning and premium
          conditioning to restore softness and prevent cracking.
        </FeatureItem>
        <FeatureItem data-id="element-1010" data-mp="kvz394ut77kb">
          <strong data-id="element-1011" data-mp="kufkn7lokkfd">Surface Sanitization:</strong> Steam cleaning of vents, cup
          holders, and dashboard to kill bacteria and remove sticky residues.
        </FeatureItem>
        <FeatureItem data-id="element-1012" data-mp="bu9c804uaan2">
          <strong data-id="element-1013" data-mp="btprkbnt185c">Crystal Clear Glass:</strong> Streak-free cleaning of all
          interior and exterior windows and mirrors.
        </FeatureItem>
      </ul>

      <h2 data-id="element-1014" data-mp="2wkqc4u1ikbrs">The Ultimate Value and Convenience</h2>
      <p data-id="element-1015" data-mp="2wmkymcsfobxz">
        Booking a Full Detail is the most cost-effective way to completely reset
        your vehicle's condition. Whether you are preparing to sell your car,
        returning a lease, or simply want to fall in love with your daily driver
        all over again, this package delivers unmatched results. Because we are
        a fully mobile operation, you don't have to waste your day in a waiting
        room. We bring our own water and detailing equipment, and we require
        access to a standard electrical outlet at the service location.
      </p>

      <h2 data-id="element-1016" data-mp="2accizf6ke0si">Related Services</h2>
      <RelatedLinks links={[['/wash-wax', 'Wash & Wax'], ['/services/interior-detailing', 'Interior Detailing'], ['/services/engine-bay-detailing', 'Engine Bay Detailing'], ['/specials', 'Current Specials']]} data-id="element-1017" data-mp="2ab1h5kwoj341" />
    </ServicePageLayout>;
}